import { PopupBiddingChoiceType } from "../popup/PopupBiddingTakeSuit";
import { TrumpSuit } from "../state/TableStateMachine";

export function PopupBiddingChoiceTypeToTrumpSuit(choiceType: PopupBiddingChoiceType): TrumpSuit
{
    switch (choiceType) {
        case PopupBiddingChoiceType.CLUBS:
            return TrumpSuit.CLUBS;
        case PopupBiddingChoiceType.DIAMONDS:
            return TrumpSuit.DIAMONDS;
        case PopupBiddingChoiceType.HEARTS:
            return TrumpSuit.HEARTS;
        case PopupBiddingChoiceType.SPADES:
            return TrumpSuit.SPADES;
        case PopupBiddingChoiceType.NOTRUMPS:
            return TrumpSuit.NOTRUMPS;
        case PopupBiddingChoiceType.ALLTRUMPS:
            return TrumpSuit.ALLTRUMPS;
        default:
            return TrumpSuit.UNDEFINED;
    }
}